export default {
      id: "external-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#external",
      toString: function () {
        return this.url;
      }
    }